<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Monto Asegurado v/s Prima</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>

          
           <b-row class="my-1">
              <b-col sm="2">
                <label>Fecha Desde</label>
              </b-col>
              <b-col sm="3">
                <b-input-group> 
                    <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                </b-input-group>
              </b-col>
              </b-row>
              
              <b-row class="my-1">
              <b-col sm="2">
                <label>Fecha Hasta</label>
              </b-col>
              <b-col sm="3">
                <b-input-group> 
                    <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                </b-input-group>
              </b-col>
             
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
             <b-col sm="2">
                <!-- <b-form-group> -->
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.idnacionase"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.nombreaseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row> 
            
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insercion" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <!-- <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button> -->
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiMtoAsegPri from "@/components/services/apiMtoAsegPri";
import apiBaseDatosResoluc from "@/components/services/apiBaseDatosResoluc";
import apiConCorredor  from "@/components/services/apiConCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "Renovaciones",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      data: [],
     
      mostrarFechas: true,
      datosFormulario: {
          fdesde: "",
          fhasta:"",
          poliza:"",
          idnacionase :"",
          nombreaseg:"",
          
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },


    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insercion() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.fdesde = "";
      this.datosFormulario.fhasta = "";
      this.datosFormulario.poliza = "";
      this.datosFormulario.idnacionase = "";
      this.datosFormulario.nombreaseg = "";
      this.hasPoliza = false;

      return apiMtoAsegPri
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo ='0';
          this.datosFormulario.poliza='0';
          this.datosFormulario.nombreaseg='Todos';
          this.datosFormulario.idnacionase='Todos';

          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
              this.datosFormulario.idnacionase = lista_data[i]["idnacionase"];
              this.datosFormulario.nombreaseg = lista_data[i]["nombreaseg"];
          }
          console.log(response.data.res);
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");

      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
    
      var p_fdesde = this.datosFormulario.fdesde;
      var p_fhasta = this.datosFormulario.fhasta;
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;

       return apiMtoAsegPri
      .validar(p_email, p_usuario, p_fdesde, p_fhasta
        ).then( (response)=>{
            // console
            response.data = this.keysMinuscula(response.data); 
             this.data = response.data.res;
            if (response.data.festado.resultado.estado != "error"){
                  this.crearNotificacion(
                    "Información",
                    "El listado de la consulta será enviado a su correo electrónico",
                    "success"
                  );
                  this.$Progress.finish();
                  return apiMtoAsegPri
                  .recuperar(p_email, p_usuario, p_poliza, p_fdesde, p_fhasta
                    ).then( (response)=>{
                        // console
                        response.data = this.keysMinuscula(response.data); 
                        this.data = response.data.res;
                        this.$Progress.finish();
                    })
                    .catch((error)=>{
                        this.$Progress.finish();
                        this.mensaje= error;
                        this.variant="danger";
                        this.showAlert();
                      });
                      }
            else{
                  this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
                      }
                  this.$Progress.finish();
                  })
          .catch((error)=>{
            this.$Progress.finish();
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
     
      var p_email= this.$session.get("mail");
      var p_ejecutivo= this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo==""){
          p_ejecutivo ='0';
      }

      if (p_poliza=="") {
          p_poliza ='0';
      }
        
      if (p_poliza=="0") {
          this.datosFormulario.idnacionase ='Todos';
          this.datosFormulario.nombreaseg ='Todos';
          this.$Progress.finish();
      }
      else{
            return apiBaseDatosResoluc
              .consulta_poliza(
                p_email, p_ejecutivo, p_poliza
              ).then((response) => {
                response.data = this.keysMinuscula(response.data);

                var Listapoliza = response.data.res;
                for (var i = 0; i < Listapoliza.length; i++) {
                  this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
                  this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
                  this.hasPoliza = true;
                }
                this.$Progress.finish();
                this.consulta_contratante(); 
              })
              .catch((error) => {
                this.mensaje= error;
                this.variant="danger";
                this.showAlert();
                this.$Progress.finish();
              })
      };
    },

    consulta_contratante: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_contratante = this.datosFormulario.contratante == '' ? '0': this.datosFormulario.contratante; 
      var p_email = this.$session.get("mail");
      if ((p_contratante==0) || (p_contratante=="")){
          this.mensaje= "Ingrese SR Contratante";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, p_contratante
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.idnacionase = InfoContratante[i]["peridnacion"];
            this.datosFormulario.nombreaseg  = InfoContratante[i]["pernombreimp"];
          }

          // if (p_poliza=='0'){
          //    this.datosFormulario.idnacionase ='Todos';
          //    this.datosFormulario.nombreaseg ='Todos';
          // }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    DatosContratantes: function(){
      
      var p_email = this.$session.get("mail");
      
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data1 = response.data.res;
            this.$Progress.finish();
         
          this.$Progress.finish();
          this.modalContratante = true;
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    buscarcorredor() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      return apiConCorredor
        .consulta_corredor(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },
   
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insercion();    
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
